import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, BasicUserInfo, UserService } from 'sv-shared';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  currentUser: BasicUserInfo;
  constructor(
    private _authenticationService: AuthenticationService,
    private _router: Router,
  ) { }

  ngOnInit(): void {
    this.currentUser = this._authenticationService.getCurrentUser();
  }

  classApplied = false;
  toggleClass() {
    this.classApplied = !this.classApplied;
  }
  logOut() {
    localStorage.clear();
    sessionStorage.clear();
    this._router.navigate(['/authentication/signin']);
  }

}
